import { VENOMBLADE } from '../cards/attack/venomblade';
import { AEGIS } from '../cards/defense/aegis';
import { BRACE } from '../cards/defense/brace';
import type { EnemyTemplate } from './template';

/** HEX-83 roster (docs/enemies.md). Epic tier: 4×3, 4 dice, optimal-vs-player AI.
 * A stonewall controller — the epic AI raises Aegis/Brace when threatened
 * (blocking + weaken), and grinds you out with the Venomblade poison while it
 * turtles. Wins by attrition, not by hitting.
 *
 * The doc's third block card was Bulwark (2×2), but three 2×2 cards cannot pack
 * into the 4×3 epic grid (every 2×2 occupies col 1, which holds only 4 cells).
 * Bulwark → Brace (2×1, rotated to a column) keeps the two-shield + poison
 * identity and fits. */
export const WARDEN_OF_THORNS: EnemyTemplate = {
  id: 'warden-of-thorns',
  name: 'Warden of Thorns',
  glyph: '✠', // warden's cross emblem
  tier: 'epic',
  hp: 38,
  loadout: [
    { card: AEGIS, origin: { row: 0, col: 0 }, rotated: false },
    { card: BRACE, origin: { row: 0, col: 2 }, rotated: true },
    { card: VENOMBLADE, origin: { row: 2, col: 0 }, rotated: false },
  ],
  drops: { gold: 20 },
};
